import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_InstallmentsList = _resolveComponent("InstallmentsList")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_NoPayments = _resolveComponent("NoPayments")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, {
        key: 0,
        title: _ctx.$t('loading'),
        fullscreen: ""
      }, null, 8, ["title"]))
    : (_ctx.installments && _ctx.installments.installments.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_InstallmentsList, {
            title: _ctx.$t('InstallmentsList-Title'),
            "installment-details": _ctx.installments,
            onSelectInstallmentItem: _ctx.handleSelectInstallment
          }, null, 8, ["title", "installment-details", "onSelectInstallmentItem"])
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ErrorMessage)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_NoPayments)
          ]))
}